import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Cancel = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.9999 3.33337C13.0356 3.33337 3.33325 13.0357 3.33325 25C3.33325 36.9644 13.0356 46.6667 24.9999 46.6667C36.9642 46.6667 46.6666 36.9644 46.6666 25C46.6666 13.0357 36.9642 3.33337 24.9999 3.33337ZM24.9999 42.992C21.5987 42.9907 18.2676 42.0255 15.3926 40.2082C12.5176 38.3909 10.2165 35.7961 8.75607 32.7244C7.29564 29.6527 6.73567 26.23 7.14106 22.8531C7.54646 19.4762 8.90062 16.2833 11.0466 13.6445L36.3554 38.9512C33.1511 41.5704 29.1385 42.999 24.9999 42.9942V42.992ZM38.9533 36.3555L13.6444 11.0489C17.1004 8.25357 21.4686 6.8363 25.9074 7.0702C30.3462 7.30409 34.5413 9.1726 37.6843 12.3156C40.8274 15.4587 42.6959 19.6538 42.9298 24.0926C43.1637 28.5313 41.7464 32.8996 38.9511 36.3555H38.9533Z"
        fill={color}
      />
    </svg>
  )
}
